/**
 * Heurística de tipo de flag (spec 2026-07-07-admin-flags-editable-values):
 * default/valor exactamente 'true' o 'false' ⇒ flag booleano (UI de toggle);
 * cualquier otro string ⇒ flag de valor libre (UI de texto), p.ej. el JSON
 * de map_default_center.
 */
export function isBooleanFlag(value: string | undefined | null): boolean {
  return value === 'true' || value === 'false';
}

export function isTruthy(value: string | undefined | null): boolean {
  if (!value) return false;
  return value === 'true' || value === '1' || value === 'yes';
}
